//系统标签
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import XtSvg from "@/components/Xt/Svg";

export default observer(({ data, type, className }) => {
  const t = useTranslation();
  const { finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    console.log(data);
    const obj = {
      WARMING: {
        label: t("finance.productStatus_WARMING"),
        cls: styles.WARMING,
      },
      PRE_SUBSCRIBING: {
        label: t("finance.productStatus_PRE_SUBSCRIBING"),
        cls: styles.PRE_SUBSCRIBING,
      },
      SUBSCRIBING: {
        label: t("finance.productStatus_SUBSCRIBING"),
        cls: styles.SUBSCRIBING,
      },
      PENDING: {
        label: t("finance.productStatus_PENDING"),
        cls: styles.PENDING,
      },
      ONGOING: {
        label: type === "staking" ? t("finance.productStatus_MINING") : t("finance.productStatus_ONGOING"),
        cls: styles.ONGOING,
      },
      MINING: {
        label: t("finance.productStatus_MINING"),
        cls: styles.MINING,
      },
      CLOSED: {
        label: t("finance.productStatus_CLOSED"),
        cls: styles.CLOSED,
      },
    };

    return obj[data];
  }, [data]);

  if (!selfData) return <></>;

  return (
    <div className={cx(styles.main, selfData.cls, className)}>
      <div>{selfData.label}</div>
      <XtSvg icon="star2" />
    </div>
  );
});
